import api, {prepareQueryParameters} from "@/store/api";
import {getFileFromHex} from "@/store/helpers";

const emptyState = () => {
    return {
        items: [],
        data: [],
        filter: [],
        loading: false,
    }
}

export default {
    namespaced: true,
    state: emptyState(),
    getters: {},
    actions: {
        list(store: any) {
            store.commit('setFilter', []);
            store.commit('setLoading', true);
            api.get('exports/list').then(data => {
                store.commit('setItems', data.data);
                store.commit('setFilter', data.data);
                store.commit('setLoading', false);
            }).catch(() => {
                store.commit('setItems', []);
                store.commit('setFilter', []);
                store.commit('setLoading', false);
            })
        },
        exportAttachment(store: any, { exportId }: { exportId: number }) {
            const newWindow = window.open();
            api.get(`exports/export-attachment?${prepareQueryParameters({ exportId })}`).then((response) => {
                const file = getFileFromHex(response.data);
                const fileURL = URL.createObjectURL(file);
                // @ts-ignore
                newWindow.location.href = fileURL;
            });
        },
        markRead(store: any, params: any) {
            store.commit('setItemRead', params);
            return api.post('exports/mark', params).then((data: any) => {}).catch(error => {
                store.dispatch("alert/warning", error.response.data.status, { root: true });
            });
        },
    },
    mutations: {
        setItems(state: any, data: any) {
            state.data = data;
            state.items = data;
        },
        setItemRead(state: any, data: any) {
            state.items[data.index].read = true;
        },
        setFilter(state: any, data: any) {
            for (const i in data) {
                const date = new Date(data[i].date);
                const year = date.getFullYear();
                if(!state.filter.includes(year)) {
                    state.filter.push(year);
                }
            }
            state.filter.sort(function(a:any,b:any){return b-a});
        },
        filter(state: any, filteredYear: any) {
            if (filteredYear) {
                state.items = [];
                const data = state.data;
                for (const i in data) {
                    const date = new Date(data[i].date);
                    const year = date.getFullYear();
                    if(year === filteredYear) {
                        state.items.push(data[i]);
                    }
                }
            } else {
                state.items = state.data;
            }
        },
        setLoading(state: any, loading: boolean = false) {
            state.loading = loading;
        },
        reset (state: any) {
            Object.assign(state, emptyState());
        }
    }
};
